<template>
  <message-bubble :isMine="isMine" :message="message">
    <div class="face-element-wrapper">
      <!-- <span>[自定义表情]</span> -->
      <img :src="url" alt="[自定义表情]" />
    </div>
  </message-bubble>
</template>

<script>
import MessageBubble from "../message-bubble";
export default {
  name: "FaceElement",
  props: {
    payload: {
      type: Object,
      required: true,
    },
    message: {
      type: Object,
      required: true,
    },
    isMine: {
      type: Boolean,
    },
  },
  components: {
    MessageBubble,
  },
  computed: {
    url() {
      //data: "xx02@2x"  http://148.70.221.198/pc/emotions/face/xx15@2x.png
      //index: 1
      let name = "";
      if (this.payload.data.indexOf("@2x") > 0) {
        name = this.payload.data;
      } else {
        name = this.payload.data + "@2x";
      }
      return `http://148.70.221.198/pc/emotions/face/${name}.png`;
    },
  },
};
</script>

<style scoped>
.face-element-wrapper img {
  max-width: 100px;
}

.face-element-wrapper span {
  color: #ff8c1a;
}
</style>
